import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { verifyEmail } from '../api/auth'
import { LoadingSpinner } from '../components/LoadingSpinner'
import styles from './VerifyEmailPage.module.css'

type VerifyState = 'loading' | 'success' | 'error'

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [state, setState] = useState<VerifyState>('loading')

  useEffect(() => {
    const token = searchParams.get('token')

    if (!token) {
      navigate('/', { replace: true })
      return
    }

    let cancelled = false

    const doVerify = async () => {
      try {
        await verifyEmail(token)
        if (!cancelled) setState('success')
      } catch {
        if (!cancelled) setState('error')
      }
    }

    doVerify()

    return () => {
      cancelled = true
    }
  }, [searchParams, navigate])

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logoRow}>
          <img src="/icono-app-ui.svg" alt="" aria-hidden="true" className={styles.isotipo} />
          <span className={styles.brand}>Fásico</span>
        </div>

        {state === 'loading' && (
          <div className={styles.stateBlock}>
            <LoadingSpinner size="lg" message="Verificando tu email..." />
          </div>
        )}

        {state === 'success' && (
          <div className={styles.stateBlock}>
            <div className={styles.iconSuccess} aria-hidden="true">✓</div>
            <h1 className={styles.title}>¡Email verificado!</h1>
            <p className={styles.body}>Ya puedes generar documentos con Fásico.</p>
            <button
              type="button"
              className={styles.btnPrimary}
              onClick={() => navigate('/', { replace: true })}
            >
              Ir al inicio
            </button>
          </div>
        )}

        {state === 'error' && (
          <div className={styles.stateBlock}>
            <div className={styles.iconError} aria-hidden="true">✕</div>
            <h1 className={styles.title}>Enlace inválido</h1>
            <p className={styles.body}>
              El enlace de verificación es inválido o ya fue utilizado.
            </p>
            <button
              type="button"
              className={styles.btnPrimary}
              onClick={() => navigate('/', { replace: true })}
            >
              Volver al inicio
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
